"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./toPropertyKey-ec4a2a72.js"),
  t = require("react"),
  a = require("prop-types"),
  n = require("./assistiveText-80858a8d.js"),
  l = require("./taggedTemplateLiteral-97b463ad.js"),
  r = require("styled-components"),
  i = require("polished/lib/helpers/rem"),
  o = require("./grid-965d799c.js"),
  c = require("./gradients-74ddcb08.js"),
  d = require("./extends-fa579b0f.js"),
  s = require("./objectWithoutProperties-2581b642.js"),
  u = require("./getPrototypeOf-6e942d92.js"),
  h = require("classnames"),
  f = require("./typography-fb2881fe.js"),
  m = require("./styles-df7980c2.js");
function p(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var g = p(t),
  v = p(a),
  y = p(r),
  T = p(i),
  b = p(h),
  x = ["className", "svgRef"];
function V(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var a,
      n = u._getPrototypeOf(e);
    if (t) {
      var l = u._getPrototypeOf(this).constructor;
      a = Reflect.construct(n, arguments, l);
    } else a = n.apply(this, arguments);
    return u._possibleConstructorReturn(this, a);
  };
}
var _ = function (e) {
  u._inherits(a, e);
  var t = V(a);
  function a() {
    return u._classCallCheck(this, a), t.apply(this, arguments);
  }
  return u._createClass(a, [{
    key: "render",
    value: function value() {
      var e = this.props,
        t = e.className,
        a = e.svgRef,
        n = s._objectWithoutProperties(e, x);
      return g["default"].createElement("svg", d._extends({
        width: "300",
        height: "24",
        viewBox: "0 0 300 24",
        fill: "currentColor",
        className: b["default"]("nmx-icon nmx-credential-logo nmx-credential-logo__ibd", t),
        ref: a
      }, n), g["default"].createElement("path", {
        fill: "#696969",
        d: "m0 23.288 1.88-2.608V3.56L0 .952h7.25L5.37 3.56v17.12l1.88 2.608H0zm20.877 0c-2.014-3.41-7.988-12.439-7.988-12.439v12.44h-2.685V7.036l-1.88-2.54h4.028l7.854 11.836V4.429h2.685v18.86h-2.014zm9.868 0h2.484L39.271 4.43h-4.498l1.208 1.672-3.692 11.636L28.06 4.43h-4.095l1.209 1.672 5.571 17.187zm19.602 0h-9.264V4.43h9.801l-1.007 2.475h-5.572v5.483h5.438l-1.074 2.608h-4.364v5.551h7.183l-1.141 2.742zm1.947-.602c1.342.669 3.155 1.003 4.9 1.003 4.162 0 6.444-2.54 6.444-5.818 0-2.871-2.441-4.284-4.636-5.553-1.792-1.037-3.42-1.979-3.42-3.542 0-2.675 4.7-2.541 6.042-.936l1.007-2.809c-1.275-.735-2.82-.936-4.229-.936-3.692 0-6.041 1.872-6.041 4.949 0 3.313 2.461 4.68 4.674 5.91 1.807 1.004 3.448 1.916 3.448 3.72 0 3.01-5.37 3.01-7.317 1.137l-.872 2.875zm19.4-15.782v16.384h-3.222V6.904h-4.968l.739-2.475h11.479l.872 2.475h-4.9z",
        className: "icon-fill"
      }), g["default"].createElement("path", {
        fill: "#696969",
        d: "M76.259 13.658c0 4.28 1.745 10.031 7.048 10.031 5.035 0 7.25-5.283 7.25-9.563S88.812 4.095 83.51 4.095c-5.035 0-7.25 5.283-7.25 9.563zm3.356-.134c0-2.34.403-6.821 3.692-6.821 3.424 0 3.894 5.216 3.894 7.557 0 2.34-.403 6.821-3.692 6.821-3.424 0-3.894-5.216-3.894-7.557zm22.354 9.764-5.773-8.426v8.426h-3.222V6.368l-1.41-1.939h7.049c3.155 0 5.638 2.14 5.638 5.283 0 2.81-1.275 4.95-4.162 5.484l5.975 8.092h-4.095zM98.076 6.904h-1.88v6.152h1.947c1.544 0 2.886-1.137 2.886-3.143 0-1.739-1.074-3.01-2.953-3.01z",
        "clip-rule": "evenodd",
        className: "icon-fill",
        fillRule: "evenodd"
      }), g["default"].createElement("path", {
        fill: "#696969",
        d: "M106.668 7.238c0 1.003-.268 2.14-.805 3.076 1.812-.735 2.685-2.541 2.685-4.012 0-1.739-1.074-2.541-2.081-2.541-.873 0-1.678.601-1.678 1.738 0 .937.671 1.605 1.879 1.739zm8.056 16.452c-1.746 0-3.558-.335-4.901-1.004l.873-2.875c1.947 1.872 7.317 1.872 7.317-1.137 0-1.804-1.641-2.716-3.448-3.72-2.213-1.23-4.675-2.597-4.675-5.91 0-3.077 2.35-4.95 6.042-4.95 1.41 0 2.954.202 4.229.937l-1.007 2.809c-1.342-1.605-6.041-1.739-6.041.936 0 1.563 1.627 2.505 3.419 3.542 2.195 1.27 4.636 2.682 4.636 5.553 0 3.277-2.282 5.818-6.444 5.818z",
        className: "icon-fill"
      }), g["default"].createElement("path", {
        fill: "#696969",
        d: "M126.874 23.288h7.586c5.169 0 7.652-2.407 7.585-6.42 0-2.675-1.947-4.815-4.095-5.35 1.813-.535 3.222-2.274 3.222-5.082 0-2.81-2.013-5.484-6.578-5.484h-7.72l1.745 2.407v17.522l-1.745 2.407zm5.169-19.795h2.484c2.215 0 3.289 1.538 3.222 3.143 0 2.34-1.343 3.812-3.692 3.812h-2.014V3.493zm0 9.697h3.021c2.148 0 3.558 1.605 3.558 3.812 0 2.073-1.343 3.611-3.894 3.611h-2.685V13.19z",
        "clip-rule": "evenodd",
        className: "icon-fill",
        fillRule: "evenodd"
      }), g["default"].createElement("path", {
        fill: "#696969",
        d: "M150.772 23.556c-4.028 0-6.377-2.475-6.377-7.29V6.101l-1.209-1.672h4.431V16.2c0 3.01 1.074 4.615 3.289 4.615 2.148 0 3.357-1.605 3.357-4.481V6.436l-1.477-2.007h4.363v12.038c0 4.28-2.081 7.089-6.377 7.089zm8.257-.87c1.342.669 3.155 1.003 4.9 1.003 4.162 0 6.377-2.54 6.445-5.818 0-2.871-2.442-4.284-4.636-5.553-1.792-1.037-3.42-1.979-3.42-3.542 0-2.675 4.699-2.541 6.042-.936l1.007-2.809c-1.276-.735-2.82-.936-4.23-.936-3.692 0-6.041 1.872-6.041 4.949 0 3.313 2.462 4.68 4.675 5.91 1.806 1.004 3.447 1.916 3.447 3.72 0 3.01-5.37 3.01-7.317 1.137l-.872 2.875zm13.761.602V6.235l-1.342-1.806h4.564v18.86h-3.222zm10.07-12.438s5.974 9.027 7.988 12.438h2.081V4.43h-2.685v11.904l-7.921-11.837h-4.028l1.88 2.541v16.251h2.685V10.85zm23.293 12.438h-9.33V5.5l-.739-1.07h10.539l-1.007 2.475h-5.571v5.483h5.437l-1.074 2.608h-4.363v5.551h7.183l-1.075 2.742zm1.947-.602c1.343.669 3.155 1.003 4.901 1.003 4.162 0 6.444-2.54 6.444-5.818 0-2.871-2.441-4.284-4.636-5.553-1.792-1.037-3.42-1.979-3.42-3.542 0-2.675 4.632-2.541 6.042-.936l1.007-2.809c-1.275-.735-2.819-.936-4.229-.936-3.692 0-6.042 1.872-6.042 4.949 0 3.313 2.462 4.68 4.675 5.91 1.807 1.004 3.448 1.916 3.448 3.72 0 3.01-5.37 3.01-7.317 1.137l-.873 2.875zm16.715 1.004c-1.745 0-3.557-.335-4.9-1.004l.873-2.875c1.946 1.872 7.317 1.872 7.317-1.137 0-1.804-1.641-2.716-3.448-3.72-2.213-1.23-4.675-2.597-4.675-5.91 0-3.077 2.35-4.95 6.042-4.95 1.409 0 2.953.202 4.229.937l-1.007 2.809c-1.343-1.605-6.042-1.739-6.042.936 0 1.563 1.628 2.505 3.42 3.542 2.194 1.27 4.636 2.682 4.636 5.553 0 3.277-2.283 5.818-6.445 5.818z",
        className: "icon-fill"
      }), g["default"].createElement("path", {
        fill: "#696969",
        d: "M236.966 23.288h7.585c6.109 0 9.264-4.012 9.264-11.636 0-6.554-3.021-10.7-9.599-10.7h-7.25l1.678 2.474v17.32l-1.678 2.542zm5.236-19.661h1.745c4.296 0 6.176 2.942 6.176 8.36 0 6.018-2.148 8.56-5.84 8.56h-2.081V3.626zm22.488 19.661-1.41-4.815h-5.437l-1.41 4.815h-3.356l6.176-17.12-.672-1.739h3.827l6.041 18.86h-3.759zm-4.095-13.91-2.148 6.688h4.162l-2.014-6.688z",
        "clip-rule": "evenodd",
        className: "icon-fill",
        fillRule: "evenodd"
      }), g["default"].createElement("path", {
        fill: "#696969",
        d: "M270.463 6.235v17.053h3.222V4.43h-4.565l1.343 1.806zm16.312 17.053h-8.928V5.366l-.671-.937h3.961v16.117h6.712l-1.074 2.742zm7.183 0v-7.891L300 4.497h-4.968l1.075 1.47-3.491 6.621-4.229-8.092h-3.961l1.141 1.538 5.169 9.43v7.824h3.222z",
        className: "icon-fill"
      }));
    }
  }]), a;
}(g["default"].PureComponent);
_.displayName = "IbdIcon";
var C = ["className", "svgRef"];
function z(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var a,
      n = u._getPrototypeOf(e);
    if (t) {
      var l = u._getPrototypeOf(this).constructor;
      a = Reflect.construct(n, arguments, l);
    } else a = n.apply(this, arguments);
    return u._possibleConstructorReturn(this, a);
  };
}
var k,
  L,
  A,
  N,
  O,
  R,
  w,
  q,
  E,
  j,
  P,
  M,
  B,
  U,
  D,
  S,
  F,
  $,
  H,
  I,
  W,
  G = function (e) {
    u._inherits(a, e);
    var t = z(a);
    function a() {
      return u._classCallCheck(this, a), t.apply(this, arguments);
    }
    return u._createClass(a, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.className,
          a = e.svgRef,
          n = s._objectWithoutProperties(e, C);
        return g["default"].createElement("svg", d._extends({
          width: "1103",
          height: "180",
          viewBox: "0 0 1103 180",
          fill: "currentColor",
          className: b["default"]("nmx-icon nmx-credential-logo nmx-credential-logo__nerdwallet", t),
          ref: a
        }, n), g["default"].createElement("path", {
          d: "M1100.23 62.367h-18.005l-2.252-19.914a3.44 3.44 0 0 0-3.418-3.054l-20.048-.006a2.514 2.514 0 0 0-2.515 2.515v20.459l.177 21.393v36.922c0 4.687.523 8.938 1.578 12.746 1.053 3.81 2.776 7.09 5.174 9.844 2.394 2.759 5.582 4.868 9.555 6.33 3.972 1.463 8.883 2.198 14.73 2.198a53.4 53.4 0 0 0 9.12-.79c2.171-.374 4.075-.795 5.71-1.26a2.503 2.503 0 0 0 1.801-2.46l-.264-15.87c-.026-1.578-1.478-2.705-3.028-2.407a30.25 30.25 0 0 1-5.447.516c-4.091 0-6.926-1.024-8.503-3.08-1.579-2.054-2.37-5.134-2.37-9.241V83.76h18.006a2.514 2.514 0 0 0 2.513-2.513V64.88a2.514 2.514 0 0 0-2.513-2.513M319.305 70.38c-2.514-3.332-5.816-6.05-9.908-8.155-3.977-2.043-8.78-3.086-14.406-3.145l.017-.01c-.09 0-.175.004-.264.005-.085 0-.167-.006-.253-.006-.311 0-.615.023-.923.031-6.493.158-12.045 1.365-16.632 3.651-4.19 2.09-7.575 4.352-10.17 6.78l-1.694-5.567a3.443 3.443 0 0 0-3.293-2.44h-19.136a2.514 2.514 0 0 0-2.515 2.514v82.302a2.514 2.514 0 0 0 2.515 2.514h23.906a2.515 2.515 0 0 0 2.515-2.516v-44.832c0-2.456.32-4.823.964-7.102.641-2.28 1.607-4.297 2.895-6.05a13.632 13.632 0 0 1 4.821-4.121c1.93-.992 4.18-1.49 6.752-1.49 2.57 0 4.703.498 6.4 1.49a10.52 10.52 0 0 1 3.947 4.033c.934 1.697 1.605 3.656 2.014 5.874.411 2.223.615 4.56.615 7.016v45.184a2.514 2.514 0 0 0 2.515 2.514h23.906a2.514 2.514 0 0 0 2.515-2.514V94.842c0-4.323-.556-8.65-1.667-12.977-1.112-4.323-2.924-8.154-5.436-11.486m215.799 55.151c-2.575-1.285-4.736-2.981-6.488-5.086-1.755-2.103-3.07-4.53-3.948-7.277a27.335 27.335 0 0 1-1.312-8.33c0-2.806.439-5.55 1.312-8.242.879-2.687 2.193-5.054 3.948-7.101 1.752-2.045 3.913-3.71 6.488-4.998 2.568-1.285 5.552-1.929 8.944-1.929 3.273 0 6.193.644 8.768 1.929 2.57 1.288 4.76 2.98 6.576 5.085 1.81 2.105 3.213 4.502 4.21 7.19a23.654 23.654 0 0 1 1.49 8.242 23.66 23.66 0 0 1-1.49 8.242c-.997 2.69-2.4 5.086-4.21 7.19-1.816 2.104-4.007 3.8-6.576 5.085-2.575 1.288-5.495 1.93-8.768 1.93-3.392 0-6.376-.642-8.944-1.93zm55.005-98.155h-23.732a2.513 2.513 0 0 0-2.513 2.513v40.93h-.35c-2.457-2.921-5.906-5.61-10.347-8.067-4.444-2.454-9.88-3.682-16.308-3.682-6.312 0-12.012 1.228-17.1 3.682-5.084 2.456-9.412 5.787-12.976 9.996-3.568 4.208-6.312 9.09-8.242 14.642-1.929 5.554-2.894 11.371-2.894 17.449 0 6.08.936 11.924 2.806 17.536 1.87 5.61 4.587 10.55 8.155 14.818 3.565 4.268 7.919 7.688 13.064 10.258 5.144 2.57 10.988 3.858 17.536 3.858.79 0 1.573-.025 2.352-.07 6.83-.147 12.664-1.405 17.477-3.805 4.146-2.068 7.528-4.298 10.175-6.684l1.857 5.724a3.441 3.441 0 0 0 3.274 2.38h17.766a2.514 2.514 0 0 0 2.514-2.513V29.888a2.513 2.513 0 0 0-2.514-2.513m157.454 34.149h-24.364a2.514 2.514 0 0 0-2.423 1.845l-14.748 53.393h-.35l-15.605-53.43a2.514 2.514 0 0 0-2.413-1.808h-25.148a2.512 2.512 0 0 0-2.419 1.83l-15.09 53.408h-.526L629.9 63.375a2.512 2.512 0 0 0-2.425-1.851h-25.59a2.514 2.514 0 0 0-2.376 3.334l28.426 82.302a2.513 2.513 0 0 0 2.376 1.694H655.6a2.517 2.517 0 0 0 2.403-1.771l16.286-52.591h.352l16.628 52.605a2.515 2.515 0 0 0 2.398 1.757h25.305c1.07 0 2.023-.678 2.375-1.69l28.589-82.302a2.513 2.513 0 0 0-2.373-3.338m144.782-34.149h-24.258a2.513 2.513 0 0 0-2.514 2.513V146.34a2.514 2.514 0 0 0 2.514 2.514h24.258a2.514 2.514 0 0 0 2.514-2.514V29.888a2.513 2.513 0 0 0-2.514-2.513m48.036 0h-24.257a2.515 2.515 0 0 0-2.515 2.513V146.34a2.515 2.515 0 0 0 2.515 2.514h24.257a2.513 2.513 0 0 0 2.514-2.514V29.888a2.513 2.513 0 0 0-2.514-2.513m-157.273 93.069c-1.753-2.103-3.07-4.53-3.948-7.277a27.375 27.375 0 0 1-1.312-8.33c0-2.806.44-5.55 1.312-8.242.879-2.687 2.195-5.054 3.948-7.101 1.753-2.045 3.915-3.71 6.488-4.998 2.57-1.285 5.552-1.929 8.945-1.929 3.272 0 6.194.644 8.767 1.929 2.57 1.288 4.76 2.98 6.577 5.085 1.811 2.105 3.212 4.502 4.208 7.19a23.624 23.624 0 0 1 1.492 8.242 23.61 23.61 0 0 1-1.492 8.242c-.996 2.69-2.397 5.086-4.208 7.19-1.817 2.104-4.008 3.8-6.577 5.085-2.573 1.288-5.495 1.93-8.767 1.93-3.393 0-6.376-.642-8.945-1.93-2.573-1.285-4.735-2.981-6.488-5.086zm61.495-61.906-20.042-.004A3.443 3.443 0 0 0 821.26 61l-2.341 7.915c-2.499-2.195-5.656-4.252-9.49-6.164-4.924-2.454-10.948-3.682-18.072-3.682h-.006c-6.312 0-12.012 1.228-17.1 3.682-5.084 2.456-9.412 5.787-12.975 9.996-3.568 4.208-6.312 9.09-8.241 14.642-1.931 5.554-2.895 11.371-2.895 17.449 0 6.08.935 11.924 2.805 17.536 1.871 5.61 4.587 10.55 8.156 14.818 3.566 4.268 7.918 7.688 13.063 10.258 5.145 2.57 10.988 3.858 17.537 3.858 1.508 0 2.994-.083 4.459-.243 5.355-.445 10.03-1.649 14.007-3.632 4.712-2.35 8.444-4.91 11.218-7.67l2.176 6.709a3.442 3.442 0 0 0 3.274 2.378l17.766.004a2.514 2.514 0 0 0 2.515-2.514V61.052a2.514 2.514 0 0 0-2.513-2.514m-352.036.777-.211-.041.327-.205c-.727 0-1.434.022-2.136.047-.58-.03-1.167-.047-1.762-.047-3.786 0-7.246.716-10.394 2.116a30.581 30.581 0 0 0-3.782 1.566c-4.637 2.314-8.286 4.838-10.97 7.566l-1.763-6.188a3.441 3.441 0 0 0-3.31-2.499l-19-.003a2.515 2.515 0 0 0-2.514 2.514v82.199a2.515 2.515 0 0 0 2.515 2.514h23.732a2.514 2.514 0 0 0 2.513-2.514v-42.258c0-1.748.353-3.788 1.053-6.119.702-2.331 1.842-4.488 3.42-6.471 1.578-1.982 3.683-3.673 6.312-5.073 2.631-1.397 5.874-2.098 9.732-2.098 1.168 0 2.37.06 3.596.175l1.156.144a2.513 2.513 0 0 0 2.747-2.257l.964-20.295a2.515 2.515 0 0 0-2.225-2.773m-129.04 35.878c.116-2.22.704-4.355 1.754-6.401a17.845 17.845 0 0 1 4.211-5.349c1.755-1.517 3.797-2.718 6.136-3.594 2.34-.877 4.91-1.315 7.716-1.315 5.728 0 10.024 1.639 12.888 4.91 2.865 3.274 4.299 7.19 4.299 11.749h-37.004zm51.208-23.85c-3.86-4.089-8.479-7.216-13.854-9.38-5.38-2.163-11.284-3.244-17.712-3.244-6.662 0-12.861 1.112-18.589 3.33-5.73 2.223-10.696 5.35-14.907 9.383-4.208 4.033-7.54 8.943-9.993 14.73-2.457 5.787-3.684 12.248-3.684 19.377 0 7.366 1.256 13.915 3.77 19.64 2.515 5.73 5.965 10.552 10.347 14.468 4.383 3.918 9.495 6.898 15.344 8.944 5.846 2.044 12.042 3.068 18.59 3.068 8.884 0 16.686-1.609 23.408-4.823 4.112-1.967 7.732-4.445 10.858-7.44a2.95 2.95 0 0 0 .043-4.21l-12.423-12.483c-1.136-1.142-3.01-1.192-4.133-.035-1.65 1.701-3.592 3.152-5.83 4.352-3.158 1.697-7.014 2.543-11.571 2.543a22.88 22.88 0 0 1-7.455-1.227c-2.396-.816-4.559-1.956-6.488-3.42-1.93-1.46-3.51-3.184-4.735-5.173-1.226-1.986-1.96-4.208-2.194-6.663h63.309a31.11 31.11 0 0 0 .172-3.333v-3.506c0-7.48-1.081-14.144-3.243-19.99-2.166-5.846-5.172-10.814-9.03-14.907m566.588 23.849c.116-2.22.702-4.355 1.754-6.401a17.84 17.84 0 0 1 4.21-5.349c1.754-1.517 3.797-2.718 6.136-3.594 2.34-.877 4.912-1.315 7.717-1.315 5.727 0 10.023 1.639 12.888 4.91 2.864 3.274 4.299 7.19 4.299 11.749h-37.004zm51.206-23.85c-3.858-4.089-8.478-7.216-13.853-9.38-5.379-2.163-11.284-3.244-17.712-3.244-6.661 0-12.86 1.112-18.588 3.33-5.73 2.223-10.697 5.35-14.907 9.383-4.209 4.033-7.54 8.943-9.993 14.73-2.459 5.787-3.684 12.248-3.684 19.377 0 7.366 1.256 13.915 3.77 19.64 2.514 5.73 5.965 10.552 10.347 14.468 4.382 3.918 9.495 6.898 15.343 8.944 5.845 2.044 12.041 3.068 18.59 3.068 8.885 0 16.687-1.609 23.409-4.823 4.11-1.967 7.73-4.445 10.858-7.44a2.952 2.952 0 0 0 .043-4.21l-12.423-12.483c-1.136-1.142-3.012-1.192-4.133-.035-1.65 1.701-3.592 3.152-5.83 4.352-3.158 1.697-7.015 2.543-11.573 2.543-2.573 0-5.058-.408-7.454-1.227-2.396-.816-4.558-1.956-6.488-3.42-1.928-1.46-3.508-3.184-4.735-5.173-1.227-1.986-1.959-4.208-2.193-6.663h63.308c.113-1.053.173-2.162.173-3.333v-3.506c0-7.48-1.081-14.144-3.244-19.99-2.165-5.846-5.17-10.814-9.03-14.907M59.724.51l-.177-.08-.179-.074A5.518 5.518 0 0 0 57.44.001H3.932A3.932 3.932 0 0 0 0 3.933v171.309c0 1.086.44 2.069 1.152 2.78a3.918 3.918 0 0 0 2.78 1.151h51.86a3.933 3.933 0 0 0 3.932-3.931V.51zm115.515 178.663a3.932 3.932 0 0 0 3.932-3.931V3.933a3.931 3.931 0 0 0-3.932-3.932h-51.86a3.932 3.932 0 0 0-3.932 3.927v55.798L61.34 1.616A5.48 5.48 0 0 0 59.724.511v118.94l58.108 58.108a5.507 5.507 0 0 0 1.97 1.26 5.501 5.501 0 0 0 1.93.354h53.507z",
          className: "icon-fill"
        }));
      }
    }]), a;
  }(g["default"].PureComponent);
G.displayName = "NerdwalletIcon";
var K = function K(e, t, a, n) {
    var i = a.smallUp(),
      o = "1rem 0";
    return a.mediumUp() ? o = "1rem 1.25rem" : i && (o = "1rem 1.25rem 0"), r.css(k || (k = l._taggedTemplateLiteral(["\n    margin: ", ";\n    background-color: ", ";\n    .nmx-credential-logo {\n      height: 100%;\n      max-height: ", ";\n      &__ibd {\n        max-height: ", ";\n      }\n    }\n    .nmx-block {\n      /** used for .nmx-block text in Moody's AMBest, etc */\n      color: ", ";\n    }\n  "])), o, m.getSectionBackgroundColor(e, t, a, n), T["default"](20), T["default"](14), m.getSectionColor(a, n));
  },
  J = y["default"].div(L || (L = l._taggedTemplateLiteral(["\n  ", ";\n"])), function (e) {
    var t = e.backgroundVariant,
      a = e.branding,
      n = e.hasAccent,
      i = e.theme,
      o = e.themeType;
    return r.css(A || (A = l._taggedTemplateLiteral(["\n      ", "\n    ", "\n    "])), K(t, a, i, o), n && "position: relative;");
  }),
  Q = y["default"].blockquote(N || (N = l._taggedTemplateLiteral(["\n  ", ";\n"])), function (e) {
    var t = e.backgroundVariant,
      a = e.branding,
      n = e.hasAccent,
      i = e.theme,
      o = e.themeType;
    return r.css(O || (O = l._taggedTemplateLiteral(["\n      ", "\n    ", "\n    "])), K(t, a, i, o), n && "position: relative;");
  }),
  X = y["default"](o.Col)(R || (R = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme.mediumDown();
    return r.css(w || (w = l._taggedTemplateLiteral(["\n      ", ";\n    "])), t && "padding-bottom: ".concat(T["default"](20)));
  }),
  Y = y["default"](f.TypographyComponent)(q || (q = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.accentColorVariant,
      a = e.accentOrientation,
      n = e.branding,
      i = e.credential,
      o = e.hasAccent,
      d = e.headingColorVariant,
      s = e.headingTextUpperCase,
      u = e.theme,
      h = e.themeType,
      f = u.colors.blue.blue;
    "darkTheme" === h && (f = "sky" === d ? u.colors.sky.sky : u.colors.text.darkTheme["default"]);
    var m = u.colors.gold.gold;
    "pcg" === n ? m = u.colors.brand.pcg.gold1 : "sky" === t && (m = u.colors.sky.sky);
    var p = 0;
    return "pcg" === n && (p = T["default"](16)), r.css(E || (E = l._taggedTemplateLiteral(["\n      margin-bottom: ", ";\n      font-size: ", ";\n      ", ";\n      line-height: ", ";\n      color: ", ";\n      text-transform: ", ";\n      && {\n        overflow: visible; /** for wide headings */ /** TODO: double-specificity needed? */\n      }\n      ", "\n      ", "\n      overflow: hidden;\n    "])), T["default"](6), u.mediumUp() ? T["default"](64) : T["default"](60), u.mediumUp() && i && "font-size: clamp(".concat(T["default"](58), ", ", "7vw", ", ").concat(T["default"](64), ")"), T["default"](60), f, s ? "uppercase" : "none", o && "vertical" === a && r.css(j || (j = l._taggedTemplateLiteral(["\n          display: block;\n          padding-left: ", ";\n          ::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            left: 0;\n            margin-right: ", ";\n            width: ", ";\n            height: ", ";\n            background-color: ", ";\n          }\n        "])), T["default"](19), T["default"](16), T["default"](3), T["default"](44), m), o && "horizontal" === a && r.css(P || (P = l._taggedTemplateLiteral(["\n          text-align: center;\n          ::after {\n            content: '';\n            display: block;\n            width: ", ";\n            ", ";\n            margin: ", " auto ", ";\n            ", ";\n            ", ";\n            ", "\n          }\n        "])), T["default"](60), "pcg" === n && "height: ".concat(T["default"](5), ";"), p, T["default"](16), "nm" === n && "padding-bottom: ".concat(T["default"](16), ";"), "nm" === n && "border-bottom: ".concat(T["default"](4), " solid ").concat(m, ";"), "pcg" === n && "".concat(c.gradients.pcgGold)));
  }),
  Z = y["default"](f.TypographyComponent)(M || (M = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.credentialLogo;
    return r.css(B || (B = l._taggedTemplateLiteral(["\n    ", "\n  "])), !t && r.css(U || (U = l._taggedTemplateLiteral(["\n        padding-bottom: 0; /** remove extra padding here that is causing visually-apparent extra section padding */\n      "]))));
  }),
  ee = y["default"].footer(D || (D = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.displayFooterText;
    return r.css(S || (S = l._taggedTemplateLiteral(["\n    padding-top: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    visibility: visible;\n\n    ", "\n  "])), T["default"](24), T["default"](12), T["default"](19), !t && r.css(F || (F = l._taggedTemplateLiteral(["\n        visibility: hidden;\n        height: 0;\n        padding: 0;\n    "]))));
  }),
  te = y["default"](G)($ || ($ = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.$themeType;
    return r.css(H || (H = l._taggedTemplateLiteral(["\n    width: auto;\n    max-height: ", ";\n    .icon-fill {\n      fill: ", ";\n    }\n  "])), T["default"](20), "darkTheme" === a ? t.colors.neutral.white : t.colors.neutral.grayDark10);
  }),
  ae = y["default"](_)(I || (I = l._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.$themeType;
    return r.css(W || (W = l._taggedTemplateLiteral(["\n    width: auto;\n    max-height: ", ";\n    .icon-fill {\n      fill: ", ";\n    }\n  "])), T["default"](20), "darkTheme" === a ? t.colors.neutral.white : t.colors.neutral.grayDark10);
  }),
  ne = function ne(t) {
    var a = t.accentOrientation,
      l = t.accentColorVariant,
      r = t.backgroundVariant,
      i = t.branding,
      o = t.className,
      c = t.content,
      d = t.descriptionTextAlign,
      s = t.displayFooterText,
      u = t.hasAccent,
      h = t.headingColorVariant,
      f = t.headingTextUpperCase,
      m = t.themeType,
      p = c.isCitable ? Q : J;
    return g["default"].createElement(p, {
      backgroundVariant: r,
      branding: i,
      className: o,
      hasAccent: u,
      themeType: m
    }, g["default"].createElement(Y, {
      accentColorVariant: l,
      accentOrientation: a,
      ariaLabel: c.headingTextAriaLabel,
      branding: i,
      className: "nmx-credential-card-heading",
      component: "h3",
      credential: c.credential,
      disableBottomPadding: !0,
      hasAccent: u,
      headingColorVariant: h,
      headingTextUpperCase: f,
      themeType: m,
      weight: 300
    }, c.headingText, c.headingTextAssistiveSupplement && g["default"].createElement(n.AssistiveTextComponent, null, c.headingTextAssistiveSupplement)), g["default"].createElement(Z, {
      className: "nmx-credential-card-description",
      credentialLogo: c.logo,
      align: d,
      themeType: m
    }, c.descriptionText), c.logo && function (t, a) {
      return "object" === e._typeof(t) ? t : "ibd" === t ? g["default"].createElement(ae, {
        $themeType: a
      }) : "nerdwallet" === t ? g["default"].createElement(te, {
        $themeType: a
      }) : null;
    }(c.logo, m), c.additionalDescription && g["default"].createElement(g["default"].Fragment, null, c.additionalDescription), c.footerText && g["default"].createElement(ee, {
      displayFooterText: s
    }, c.footerText));
  };
ne.propTypes = {
  accentColorVariant: v["default"].oneOf(["gold", "sky"]),
  accentOrientation: v["default"].oneOf(["horizontal", "vertical"]),
  backgroundVariant: v["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: v["default"].oneOf(["nm", "pcg"]),
  className: v["default"].string,
  content: v["default"].shape({
    logo: v["default"].oneOf(["ibd", "nerdwallet"]) || v["default"].element,
    descriptionText: v["default"].node.isRequired,
    footerText: v["default"].node,
    headingText: v["default"].node.isRequired,
    headingTextAriaLabel: v["default"].string,
    headingTextAssistiveSupplement: v["default"].node,
    isCitable: v["default"].bool,
    additionalDescription: v["default"].any,
    sup1: v["default"].any,
    sup2: v["default"].any
  }).isRequired,
  descriptionTextAlign: v["default"].oneOf(["inherit", "left", "center", "right"]),
  displayFooterText: v["default"].bool,
  hasAccent: v["default"].bool,
  headingColorVariant: v["default"].oneOf(["default", "sky"]),
  headingTextUpperCase: v["default"].bool,
  sup1: v["default"].any,
  sup2: v["default"].any,
  themeType: v["default"].oneOf(["lightTheme", "darkTheme"])
}, ne.defaultProps = {
  accentOrientation: "vertical",
  accentColorVariant: "gold",
  backgroundVariant: "lightB",
  branding: "nm",
  displayFooterText: !1,
  hasAccent: !1,
  headingColorVariant: "default",
  headingTextUpperCase: !1,
  themeType: "lightTheme"
}, exports.CredentialCardColStyled = X, exports.CredentialCardContent = ne;